import * as svg from "../../../assets/credit-card-icon.svg";

import {iconBuilder} from "./iconBuilder";

const CreditCardIcon = iconBuilder(svg, "CreditCardIcon", "0 0 20 20");

export default CreditCardIcon;
